module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pane-box"
  }, [_c('div', {
    staticClass: "pane-label"
  }, [_c('div'), _vm._v(_vm._s(_vm.label) + "\n  ")]), _vm._v(" "), (_vm.dataList.length > 0) ? _c('div', {
    staticClass: "pane-photo"
  }, _vm._l((_vm.dataList), function(item, i) {
    return _c('el-image', {
      key: i,
      staticClass: "pane-photo-img",
      attrs: {
        "src": item,
        "preview-src-list": _vm.dataList
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.dataList.length <= 0) ? _c('div', {
    staticClass: "pane-photo"
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-file"
  }, [_c('i', {
    staticClass: "el-icon-warning-outline"
  }), _vm._v(" "), _c('span', [_vm._v("暂未上传")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-144fa806","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Order/components/detailPhoto.vue
// module id = 605
// module chunks = 0